import { render } from "./ReportsBarChart.vue?vue&type=template&id=0077704e"
import script from "./ReportsBarChart.vue?vue&type=script&lang=js"
export * from "./ReportsBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__